<template>
  <div class="card-tools">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "CardTools"
}
</script>
